"use client";

import { ToastContainer } from "react-toastify";
// Components
import Header from "../../Header/Header";
import UserLayout from "../../UserLayout/UserLayout";
import { useSession } from "next-auth/react";

export default function IntermediateLayout(props) {
    const { data: session, status } = useSession();
    const loading = status === "loading";

    if (session && session.user) {
        return (
            <UserLayout currentPage={props.currentPage}>
                {props.children}
            </UserLayout>
        );
    } else {
        return (
            <>
                {/* <ToastContainer
                    position="bottom-right"
                    autoClose={8000}
                    theme="dark"
                /> */}
                <div
                    className={`flex min-h-screen flex-col ${
                        props.className ? props.className : ""
                    }`}
                    style={props.style}
                >
                    {!props.withoutHeaderForAnonymous && (
                        <Header
                            currentPage={props.currentPage}
                            gradients
                            absoluteHeader
                        />
                    )}
                    <div className={`flex-grow ${props.className || null}`}>
                        {props.children}
                    </div>
                </div>
            </>
        );
    }
}
